import axios from "axios";

import type { EAnalyticsEvent } from "@/modules/analytics/consts/analytics-event";

const analyticsApi = {
  shareAnalyticsEvent: (initData: string, eventType: EAnalyticsEvent) =>
    axios({
      method: "GET",
      url: `/analytics/${eventType}`,
      headers: {
        "Init-Data": initData,
        "Content-Type": "application/json",
      },
    }),
};

export { analyticsApi };
